// @ts-nocheck
import store from '../store/storeOrder/index'
import ProductUtils from './ProductUtils';
export default class DiscountUtils {

    constructor(products) {
        this.products = products
    }

    static calculateDiscountPromotions(
        quantityProduct: number,
        priceProduct: number,
        totalPriceWithSubProducts: number,
        promo: {
            min: number,       // Z
            free: number,      // N
            percentage: number, // 100 for free, or 50 for partial
            limit?: number     // optional limit of uses per customer
        },
        timesUsed: number // how many times this promo has already been used by the customer
    ) {
        promo.limit = promo?.limit ? promo?.limit : null;
        const { min, free, percentage, limit } = promo;

        const result = {
            priceProduct,
            quantityProduct,
            quantityToGive: 0,
            quantityToSell: quantityProduct,
            discountPercentage: percentage,
            totalPriceWithoutDiscount: quantityProduct * priceProduct,
            priceProductDiscounted: quantityProduct * priceProduct,
            discount: 0,
            TotalPriceWithSubProducts: totalPriceWithSubProducts,
            text: '',
            status: false,
        };

        // this for promo has percentage < 100, offert or moitié prix
        const isPartialDiscount = percentage < 100;
        // this for promo has free articles, gratuit
        const isFullDiscount = percentage === 100;

        // 🔢 Calculate number of full promo sets
        let promoSets = Math.floor(quantityProduct / (min + free));
        if (!isFinite(promoSets)) promoSets = 0;

        // ✅ Apply limit if defined
        if (limit !== undefined) {
            const remainingUses = Math.max(0, limit - timesUsed);
            promoSets = Math.min(promoSets, remainingUses);
        }


        let quantityToGive = promoSets * free;
        if (isNaN(quantityToGive)) quantityToGive = 0;

        // 🎯 Case 1: Standard percentage discount (no buy x get y logic)
        if (min === 0 && free === 0 && isPartialDiscount) {
            // const discount = result.totalPriceWithoutDiscount * (percentage / 100);
            // result.discount = discount;
            // result.priceProductDiscounted -= discount;
            // result.text = -${percentage}%;
            // result.status = true; 

            if (limit === undefined || timesUsed < limit) {
                const discount = result.totalPriceWithoutDiscount * (percentage / 100);
                result.discount = discount;
                result.priceProductDiscounted -= discount;
                result.text = `-${percentage}%`;
                result.status = true;
            }

        }

        // 🎯 Case 2: Partial discount with "buy x get y at discount"
        else if (isPartialDiscount) {
            const isSpecific50 = min === 1 && free === 1;
            const discount = quantityToGive * priceProduct * (percentage / 100);
            result.discount = discount;
            result.priceProductDiscounted -= discount;

            if (quantityToGive > 0) {
                result.text = isSpecific50
                    ? `${quantityToGive} pizza moitié prix - ${percentage}%`
                    : `${quantityToGive} article(s) à moitié prix - ${percentage}%`;
                result.status = true;
            }
        }

        // 🎯 Case 3: 100% Free products ("Buy X get Y free")
        else if (isFullDiscount) {
            // Edge case: force promo if only one item is added
            promoSets = (quantityProduct === min && free === 1) ? 1 : Math.floor(quantityProduct / min);
            // Apply remaining uses limit
            if (limit !== undefined) {
                const remainingUses = Math.max(0, limit - timesUsed);
                promoSets = Math.min(promoSets, remainingUses);
            }

            quantityToGive = promoSets * free;

            if (quantityToGive > 0) {
                result.text = `+${quantityToGive} article(s) gratuit(s)`;
                result.status = true;
            }
        }

        result.quantityToGive = quantityToGive;
        return result;
    }






    static isProductOnPromotion() {
        store.state.cartStore.discountPromotions = 0
        store.state.cartStore?.products?.map((product, indexProduct) => {
            // The promotion applies only to the product price and does not include sub-products
            if (product?.promos?.length > 0 && product.quantity >= 1) {
                // This to get the real price of product ( I added this code to get price product if has type size  )
                const productPrice = ProductUtils.productPrice(product)
                // First check if the promotion has been affected to the product or the sub product
                let promoFound = product.promos.find((item) => item["product_id"] === product.id && item["sub_product_id"] == null) ? true : false
                if (!promoFound) {
                    product?.groups?.map((groupObj, indexGrp) => {
                        if (groupObj?.button_type == "RadioButton" && groupObj?.type == "size") {
                            promoFound = groupObj?.sub_products.find(
                                (subProductObj) => subProductObj?.checked && product?.promos[0].sub_product_id == subProductObj.id
                            ) ? true : false
                        }
                    });
                }
                // if promo found re-calculate discount
                if (promoFound) {
                    const promotions = this.calculateDisounctPromotions(
                        product.quantity,
                        productPrice,
                        0,
                        product.promos[0]
                    );
                    if (promotions?.status) {
                        product.promotion = promotions
                        store.state.cartStore.discountPromotions = store.state.cartStore.discountPromotions + product.promotion.discount
                    }
                }
            }
        })
    }

    /** Recalculate all discount [promotions, promocode, carte fidélité ] */
    static ReCalculateAllDiscounts() {
        let subTotal = store.state.cartStore?.subTotal;
        store.state.cartStore.totalFinal = subTotal;
        store.state.cartStore.discountCouponcode = store.state.cartStore.discountCouponcode || 0;
        store.state.cartStore.discountPromotions = store.state.cartStore.discountPromotions || 0;
        store.state.cartStore.discountFidelite = store.state.cartStore.discountFidelite || 0;
        const configLoyaltyCard = [] // store.state.storeData?.data?.config_loyalty || []
        const loyaltyCard =  {} // store.state.userStore?.loyaltyCard || {};

        if (store.state.cartStore.discountPromotions > 0) {
            subTotal -= store.state.cartStore.discountPromotions;
        }

        // if (configLoyaltyCard[0]?.nb_orders - 1 == loyaltyCard?.nb_orders) {
        //     store.state.cartStore.discountFidelite = subTotal * (configLoyaltyCard[0]?.percentage / 100);
        //     subTotal -= store.state.cartStore.discountFidelite;
        // }

        if (store.state?.storeData?.couponCode?.percentage) {
            store.state.cartStore.discountCouponcode = subTotal * (store.state?.storeData?.couponCode?.percentage / 100);
            subTotal -= store.state.cartStore.discountCouponcode;
        }

        store.state.cartStore.totalFinal = subTotal // + store.state.cartStore?.deliveryTotal;
        store.state.cartStore.discountTotal = store.state.cartStore?.discountFidelite + store.state.cartStore?.discountCouponcode + store.state.cartStore?.discountPromotions;

    }

}
